import { configureStore } from "@reduxjs/toolkit";
import layoutReducer from "./features/layoutSlice";
import audioReducer from "./features/audioSlice"; // Import the audio slice reducer

export const store = configureStore({
  reducer: {
    layout: layoutReducer,
    audio: audioReducer,
  },
});
